
import { FC } from "react";
import { useLocation, useParams, Navigate } from "react-router-dom";


const MapPageRedirect: FC = () => {
    const location = useLocation();

    const params = useParams();

    const searchParams = new URLSearchParams(location.search);

    if (params.species && ((searchParams.has('chart7') && searchParams.get('chart7') === 'true') || (searchParams.has('chart31') && searchParams.get('chart31') === 'true'))) {
        return <Navigate replace to={`/${params.species}/chartsandtables?${searchParams.toString()}`} />
    }

    if (params.species) {
        return <Navigate replace to={`/${params.species}/map?${searchParams.toString()}`} />
    }

    return <Navigate replace to={`/error/404`} />
}

export default MapPageRedirect;